import React, { useEffect, useState } from "react";
import stylesheet from "./sponcers.module.css";
import Footer from "../../webincludes/footer/index";
import Header from "../../webincludes/header/index";
import { Link } from "react-router-dom";
import Aboutus from "../about/index";

const affilate = () => {
  return <Aboutus />;
};

export default affilate;
